import { Button } from "@/components/ui/button";
import {
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui/drawer";
import { AlertTriangle } from "lucide-react";

interface DeleteConfirmDialogProps {
  onCancel: () => void;
  onConfirm: () => void;
}

export default function DeleteConfirmDialog({
  onCancel,
  onConfirm,
}: DeleteConfirmDialogProps) {
  return (
    <DrawerContent>
      <DrawerHeader>
        <div className="flex items-center gap-2 text-destructive">
          <AlertTriangle className="h-5 w-5" />
          <DrawerTitle>Confirmar exclusão</DrawerTitle>
        </div>
        <DrawerDescription>
          Tem certeza que deseja excluir este canal? Esta ação não pode ser desfeita.
        </DrawerDescription>
      </DrawerHeader>
      <DrawerFooter>
        <Button variant="outline" onClick={onCancel}>
          Cancelar
        </Button>
        <Button variant="destructive" onClick={onConfirm}>
          Excluir
        </Button>
      </DrawerFooter>
    </DrawerContent>
  );
}
